define(['angular'], function (angular) {
    'use strict';

    return angular
        .module('directives', [])
        .directive('uploadTrigger', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(element).on('click', function () {
                        $('#' + attrs.uploadTrigger)
                            .get(0)
                            .click();
                    });
                },
            };
        })
        .directive('dropdown', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(document).foundation('dropdown', 'reflow');
                },
            };
        })
        .directive('closeDropdown', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(element).on('click', function () {
                        $(document).foundation(
                            'dropdown',
                            'close',
                            $('[data-dropdown-content]')
                        );
                    });
                },
            };
        })
        .directive('tooltip', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $(element).on('click', function () {
                        $('#' + element.data('selector')).hide();
                    });
                },
            };
        });
});
